import s from './security.module.css';

/**
 * The two authenticator apps we recommend, and where to get each on an iPhone or an
 * Android phone. Both are free; staff pick one. Links are the publishers' own store pages.
 */
const APPS = [
  {
    name: 'Google Authenticator',
    publisher: 'Google LLC',
    ios: 'https://apps.apple.com/app/google-authenticator/id388497605',
    android: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
  },
  {
    name: 'Microsoft Authenticator',
    publisher: 'Microsoft Corporation',
    ios: 'https://apps.apple.com/app/microsoft-authenticator/id983156458',
    android: 'https://play.google.com/store/apps/details?id=com.azure.authenticator',
  },
] as const;

export function GetTheApp({ intro = true }: { intro?: boolean }) {
  return (
    <div className={s.apps}>
      {intro && (
        <p>
          Use <strong>Google Authenticator</strong> or <strong>Microsoft Authenticator</strong>. Both are
          free; pick one.
        </p>
      )}
      <table className={s.appTable} aria-label="Where to get the app">
        <thead>
          <tr>
            <th>App</th>
            <th>iPhone</th>
            <th>Android</th>
          </tr>
        </thead>
        <tbody>
          {APPS.map((a) => (
            <tr key={a.name}>
              <td>
                <strong>{a.name}</strong>
                <div className="sub2">by {a.publisher}</div>
              </td>
              <td>
                <a href={a.ios} target="_blank" rel="noopener noreferrer">
                  App Store
                </a>
              </td>
              <td>
                <a href={a.android} target="_blank" rel="noopener noreferrer">
                  Google Play
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="sub2">
        On your phone, open the <strong>App Store</strong> (iPhone) or <strong>Google Play</strong> (Android),
        search for the app's name, and install the one published by Google LLC or Microsoft Corporation. If
        you already use one of them, add Concord to it.
      </p>
    </div>
  );
}
